export default "__VITE_ASSET__DS4yk4HT__"